var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex flex-row items-center justify-center p-2 text-red-600 font-bold gap-2 border border-red-600 hover:bg-red-100 rounded-md",attrs:{"href":"https://www.youtube.com/@aboveaveragelimited","target":"_blank","rel":"noopener noreferrer","aria-label":"Watch Video Guides"}},[_c('i',{staticClass:"bi bi-youtube text-xl"}),_vm._v(" Watch Video Guides\n")])
}]

export { render, staticRenderFns }